const NavConfig = () => {
  const navConfig = [
    {
      title: 'መነሻ ገጽ',
      path: '/landing#home',
      icon: 'carbon:home',
    },
    {
      title: 'ስለ እኛ',
      path: '/landing#aboutUs',
      icon: 'carbon:information-square',
    },
    {
      title: 'ያግኙን',
      path: '/landing#contactUs',
      icon: 'ic:baseline-chat-bubble-outline',
    },
    {
      title: 'ግባ',
      path: '/login',
      icon: 'carbon:security',
    },
  ];

  return navConfig;
};

export default NavConfig;
